import { createContext } from 'react';

const peligroContext = createContext();

export default peligroContext;
